
export default {
    count: [],
    teacherCount:0,
    studentCount:0
};
